module.exports = __webpack_public_path__ + "img/15.37754e0f.jpg";